import { useEffect, useState } from 'react';
import type { GradeResult } from '../../types';
import { useStrings } from '../../state/useLocale';
import { Button } from '../../ui';

/** A slow local check explains its wait; an interrupted one can be retried. */
export function LocalCheckStatus({ checking, grade, onRetry }: {
  checking: boolean; grade: GradeResult | null; onRetry(): void;
}) {
  const s = useStrings().play;
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    setSlow(false);
    if (!checking) return;
    const timer = setTimeout(() => setSlow(true), 45_000);
    return () => clearTimeout(timer);
  }, [checking]);
  const interrupted = grade?.objectives.some(o => o.timedOut);
  return <div role="status" aria-live="polite" data-spot-check={checking?'checking':grade?(grade.passed?'passed':'retry'):'idle'}>
    {checking ? <p>{slow ? s.checkTakingLonger : s.checkingWork}</p> : interrupted ? <>
      <p>{s.checkIncomplete}</p>
      <Button type="button" onClick={onRetry}>{s.retryCheck}</Button>
    </> : null}
  </div>;
}
